export const color = {
  black: '#0B0B0B',
  blackLight: '#4D4D4D', // Secondary Text

  grey: '#737373', // Less important stuff
  greyLight: '#B5B5B5', // Inactive things
  greyLine: '#E6E6E6', // borders, dividers etc
  greyBlock: '#F9F9F9',

  hover: '#F3F3F3',

  red: '#FF3434', // Danger
  redLine: '#BB261A' // Danger
}
export const border = `1px solid ${color.greyLine}`
export const borderRadius = 4

export const space1 = 5
export const space2 = 10
export const space3 = 15
export const space4 = 20
export const space8 = 40
export const space16 = 80
export const space = {
  small: space2,
  default: space3,
  large: space4
}
// export const space = {
//   get small() {
//     console.warn('space.small is deprecated. Use space2')
//     return space2
//   },
//   get default() {
//     console.warn('space.small is deprecated. Use space3')
//     return space3
//   },
//   get large() {
//     console.warn('space.small is deprecated. Use space4')
//     return space4
//   }
// }


export const sidebarWidth = 300
export const menuWidth = 200

export const rowHeight = {
  default: 30,
  large: 40,
  extraLarge: 60
}

export const crop = {
  handle: {
    stroke: '#0B0B0B',
    fill: 'white',
    thickness: 4,
    cornerSize: 20,
    sideSize: 40
  }
}

export const discussBlockHighlight = {
  outlineStyle: 'solid',
  outlineColor: '#808080',
  outlineWidth: 4,
  mixBlendMode: 'difference'
}

export const selectArrowSize = 10

export const avatarSize = 30

const zIndexes = [
  // Bottom
  // 'old: selectable  .block__context-menu',
  // 'old: selectable__snap',
  'grid',
  'sectionControl',
  'activeBlock', // currently editing text or cropping
  'resizeHandle',
  // 'old: block--placing',
  'toolbarColor', // above blocks
  'menu',
  'singleBlock', // must be above toolbarColor
  'toolbar',
  'queue',
  'sidebar',
  'activityOverlay',
  'activityButton',
  'sidebarFilterMenuOverlay',
  'sidebarFilterMenu',
  'activity',
  'sidebarAccountMenu',
  'colorPicker',
  'modal',
  'dropdown',
  'alert',
  'tooltip'
  // Top
]
export const z = {}
zIndexes.forEach((item, i) => (z[item] = i+1))

export const interactive = ({
  primary,
  disabled,
  active,
  selected,
  notSelected,
  danger
} = {}) => {
  const invert = active || primary
  return {
    color: disabled
      ? color.greyLight
      : invert || danger
      ? 'white'
      : notSelected
      ? color.grey
      : 'inherit',
    backgroundColor: selected
      ? color.greyBlock
      : invert
      ? color.black
      : danger
      ? color.red
      : 'white',
    borderColor: invert ? 'white' : danger ? color.redLine : undefined,

    textDecoration: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',

    '&:hover': !disabled && {
      color: !invert && !danger && color.black,
      backgroundColor: invert
        ? 'rgb(51, 51, 51)'
        : danger
        ? color.redLine
        : color.greyBlock
    }
  }
}